var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStretch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.21967 19.8869L19.8869 8.21967C20.1798 7.92678 20.6547 7.92678 20.9476 8.21967C21.2405 8.51256 21.2405 8.98744 20.9476 9.28033L9.28033 20.9476C8.98744 21.2405 8.51256 21.2405 8.21967 20.9476C7.92678 20.6547 7.92678 20.1798 8.21967 19.8869Z",
    fill: "#717171"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4477 19.4583L19.1215 13.7845C19.4144 13.4916 19.8892 13.4916 20.1821 13.7845C20.475 14.0774 20.475 14.5523 20.1821 14.8452L14.5084 20.5189C14.2155 20.8118 13.7406 20.8118 13.4477 20.5189C13.1548 20.226 13.1548 19.7512 13.4477 19.4583Z",
    fill: "#717171"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStretch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/stretch.a1edccc4600ae095782ff51d34690f10.svg";